import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Componente que redirige de /:codigo a /:codigo/login
 * Útil cuando alguien accede a localhost:3000/invramirez/ sin especificar /login
 */
function TenantRedirect() {
  const { codigo } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirigir automáticamente al login del tenant
    navigate(`/${codigo}/login`, { replace: true });
  }, [codigo, navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white'
    }}>
      <div style={{ textAlign: 'center' }}>
        <i className="fas fa-spinner fa-spin" style={{ fontSize: '3rem', marginBottom: '1rem' }}></i>
        <h2>Redirigiendo...</h2>
      </div>
    </div>
  );
}

export default TenantRedirect;
